// extracted by mini-css-extract-plugin
export default {"nokiaProfileContainer":"NokiaProfile_nokiaProfileContainer__Nspan","addButton":"NokiaProfile_addButton__ALwFb"};